import { IMAGES } from './site';

// Service-area pages. Each city has genuinely unique local content — no
// find-and-replace doorway pages. "Serving" language is used deliberately:
// the company is based in the Omaha/Lincoln metro, not in every city.
export const LOCATIONS = [
  {
    slug: 'omaha-ne',
    city: 'Omaha',
    state: 'Nebraska',
    region: 'Omaha Metro',
    headline: 'Outdoor Living Design & Build in Omaha, NE',
    image: IMAGES.homeDusk,
    intro: [
      'Omaha homeowners know the value of a great backyard. From established neighborhoods like Dundee and Benson with their mature trees and character homes, to newer developments stretching west, outdoor space is where Omaha families actually live from May through October.',
      'Nebraska Backyard Living has designed and built custom outdoor kitchens, sunrooms, decks, pergolas, patios, and water & fire features across the Omaha metro for over two decades. We understand Omaha soils, Omaha weather, and the way Omaha homeowners entertain — and we build for all three.',
    ],
    localHeading: 'Built for the Way Omaha Lives',
    localPoints: [
      'Designs that respect established neighborhoods and mature landscaping',
      'Construction methods proven against Omaha freeze-thaw cycles and summer storms',
      'Entertainment-ready spaces — outdoor kitchens and fire features built for Husker Saturdays and College World Series summers',
      'Experience with older home rooflines, additions, and lot layouts across the metro',
    ],
    faqs: [
      { q: 'Do you serve all Omaha neighborhoods?', a: 'Yes. We design and build across the greater Omaha metro — from central neighborhoods like Dundee, Benson, and Aksarben to west Omaha and beyond. Your free consultation happens at your home, wherever it is.' },
      { q: 'Can you work with my older Omaha home\'s architecture?', a: 'Absolutely. Much of our Omaha work involves established homes where a sunroom, deck, or patio cover needs to look original to the house. Matching rooflines, finishes, and proportions is a core part of our design process.' },
      { q: 'When is the best time to start a patio project in Omaha?', a: 'Design can happen any time of year. Homeowners who start planning in winter or early spring typically get the earliest build slots and the most patio season out of year one.' },
    ],
    nearby: ['millard-ne', 'elkhorn-ne', 'papillion-ne', 'la-vista-ne'],
    metaTitle: 'Outdoor Living Omaha, NE | Patios, Kitchens & Sunrooms',
    metaDescription: 'Custom outdoor living design & build in Omaha, NE — patios, outdoor kitchens, sunrooms, decks & fire features. 22+ years, A+ BBB. Free consultation.',
  },
  {
    slug: 'lincoln-ne',
    city: 'Lincoln',
    state: 'Nebraska',
    region: 'Lincoln Metro',
    headline: 'Outdoor Living Design & Build in Lincoln, NE',
    image: IMAGES.homeModern,
    intro: [
      'Lincoln is a city that loves its outdoor life — from Haymarket evenings to Husker game days at home. A well-designed backyard gives Lincoln homeowners a private version of that same energy: a place to cook, gather, and unwind without leaving home.',
      'Nebraska Backyard Living serves Lincoln homeowners with the same custom design-build approach we have refined over 22+ years — outdoor kitchens, sunrooms, decks, pergolas, patios, and water & fire features designed for Lancaster County lots and Lincoln\'s climate.',
    ],
    localHeading: 'Designed for Lincoln Neighborhoods',
    localPoints: [
      'Experience with south Lincoln and Yankee Hill newer builds as well as established near-campus and Country Club-area properties',
      'Game-day-ready outdoor kitchens and covered spaces for fall Saturdays',
      'Materials selected for Lincoln\'s wind exposure and freeze-thaw winters',
      'Familiarity with Lincoln building requirements and permitting',
    ],
    faqs: [
      { q: 'Do you really serve Lincoln, or only Omaha?', a: 'Lincoln is one of our two core service areas, and it has been for years. Consultations, design, and build all happen locally — you work with the same team from first visit to final walkthrough.' },
      { q: 'Can you design for a smaller Lincoln lot?', a: 'Yes. Many Lincoln neighborhoods have compact yards where smart design matters more than square footage. Pergolas, patio covers, and vertical design can make a modest footprint live large.' },
      { q: 'What outdoor features are most popular with Lincoln homeowners?', a: 'Outdoor kitchens and covered patios lead the list — spaces that make fall entertaining comfortable. Fire features are a close second, extending backyard season on both ends of the Nebraska calendar.' },
    ],
    nearby: ['wahoo-ne', 'ashland-ne', 'omaha-ne', 'gretna-ne'],
    metaTitle: 'Outdoor Living Lincoln, NE | Nebraska Backyard Living',
    metaDescription: 'Custom patios, outdoor kitchens, sunrooms & fire features for Lincoln, NE homeowners. Locally owned, 22+ years. Free on-site consultation.',
  },
  {
    slug: 'millard-ne',
    city: 'Millard',
    state: 'Nebraska',
    region: 'Omaha Metro',
    headline: 'Outdoor Living Design & Build in Millard, NE',
    image: IMAGES.home2,
    intro: [
      'Millard is classic suburban Nebraska — established neighborhoods, mature trees, and homes from the \'70s, \'80s, and \'90s sitting on generous lots with real backyard potential. It is exactly the kind of community where thoughtful outdoor living design shines.',
      'We serve Millard homeowners with custom patios, decks, sunrooms, pergolas, outdoor kitchens, and water & fire features — with particular experience updating and reimagining the aging decks and builder-grade patios common in the area.',
    ],
    localHeading: 'Reimagining Millard\'s Established Backyards',
    localPoints: [
      'Deck renovation and replacement for Millard\'s established housing stock',
      'Designs that work around mature trees and existing landscaping',
      'Sunrooms and patio covers matched to ranch and split-level rooflines',
      'Fire features and seating areas that make big lots feel intimate',
    ],
    faqs: [
      { q: 'My Millard home has an aging wood deck. Replace or renovate?', a: 'It depends on the framing. We inspect first — if the structure is sound, re-surfacing with low-maintenance materials can be smart. If not, we will show you exactly why replacement is the better investment.' },
      { q: 'Can you build around my mature trees?', a: 'Yes, and it is one of our favorite design challenges. Mature Millard trees provide natural shade and character that we design around — often reducing the need for structures while making the finished space feel established from day one.' },
    ],
    nearby: ['omaha-ne', 'papillion-ne', 'elkhorn-ne', 'gretna-ne'],
    metaTitle: 'Outdoor Living & Landscaping Millard, NE | Nebraska Backyard Living',
    metaDescription: "Patios, decks, sunrooms & outdoor kitchens for Millard's established neighborhoods. Deck renovation specialists. Free consultation: (402) 202-9111.",
  },
  {
    slug: 'papillion-ne',
    city: 'Papillion',
    state: 'Nebraska',
    region: 'Omaha Metro',
    headline: 'Outdoor Living Design & Build in Papillion, NE',
    image: IMAGES.home3,
    intro: [
      'Papillion consistently ranks among Nebraska\'s most desirable places to live — and its backyards deserve to match. From newer neighborhoods around Shadow Lake to established streets near downtown Papio, homeowners here invest in their outdoor spaces because they genuinely use them.',
      'Nebraska Backyard Living designs and builds custom outdoor kitchens, patios, sunrooms, decks, pergolas, and fire features throughout Papillion and Sarpy County, with construction and materials chosen for local conditions.',
    ],
    localHeading: 'Papillion Backyards, Built to Be Used',
    localPoints: [
      'Family-first designs — spaces that work for weeknight dinners and weekend crowds',
      'Experience with newer Papillion builds and HOA-conscious design',
      'Covered patios and pergolas that tame west-facing afternoon sun',
      'Fire features that stretch Papillion\'s outdoor season deep into fall',
    ],
    faqs: [
      { q: 'Do you work with Papillion HOA requirements?', a: 'Yes. Many Papillion neighborhoods have architectural review processes, and we are experienced in preparing designs and documentation that move through approvals smoothly.' },
      { q: 'What works best for Papillion\'s newer homes?', a: 'Newer Papillion builds often start with a plain concrete pad. The biggest transformations come from layered design — an extended patio, a pergola or cover for shade, and a fire feature or outdoor kitchen to anchor the space.' },
    ],
    nearby: ['la-vista-ne', 'millard-ne', 'omaha-ne', 'gretna-ne'],
    metaTitle: 'Outdoor Living Papillion, NE | Nebraska Backyard Living',
    metaDescription: 'Custom patios, pergolas, outdoor kitchens & fire features in Papillion, NE. HOA-experienced, family-first designs. Free on-site consultation.',
  },
  {
    slug: 'la-vista-ne',
    city: 'La Vista',
    state: 'Nebraska',
    region: 'Omaha Metro',
    headline: 'Outdoor Living Design & Build in La Vista, NE',
    image: IMAGES.pergolaModern,
    intro: [
      'La Vista sits at the center of everything in the metro — and its backyards tend to be efficient, practical spaces where smart design makes an outsized difference. When square footage is modest, every design decision counts.',
      'We help La Vista homeowners maximize their outdoor space with custom patios, pergolas, patio covers, outdoor kitchens, and fire features — designs scaled to the lot, not copied from a bigger one.',
    ],
    localHeading: 'Smart Design for La Vista Lots',
    localPoints: [
      'Space-efficient layouts that make compact yards feel expansive',
      'Pergolas and covers that add definition without closing in the space',
      'Multi-purpose designs — dining, lounging, and cooking in one cohesive plan',
      'Central-metro availability for consultations and builds',
    ],
    faqs: [
      { q: 'My La Vista yard is small. Is a custom design still worth it?', a: 'Small yards benefit the most from professional design. When every square foot matters, the difference between a builder-grade pad and a designed space — right-sized patio, vertical shade, one strong focal point — is enormous.' },
      { q: 'Can an outdoor kitchen work on a smaller patio?', a: 'Yes. Compact grill islands with integrated storage deliver most of the function of a large kitchen in a fraction of the footprint. We design to your space and how you actually cook.' },
    ],
    nearby: ['papillion-ne', 'omaha-ne', 'millard-ne', 'gretna-ne'],
    metaTitle: 'Outdoor Living & Landscaping La Vista, NE | Nebraska Backyard Living',
    metaDescription: 'Space-smart patios, pergolas & outdoor kitchens for La Vista, NE homes. 22+ years serving the metro. Free consultation: (402) 202-9111.',
  },
  {
    slug: 'gretna-ne',
    city: 'Gretna',
    state: 'Nebraska',
    region: 'Omaha Metro',
    headline: 'Outdoor Living Design & Build in Gretna, NE',
    image: IMAGES.lawn,
    intro: [
      'Gretna is one of the fastest-growing communities in Nebraska, and its new neighborhoods come with something valuable: space. Larger lots at the metro\'s western edge give homeowners room for the kind of complete outdoor living environments most people only dream about.',
      'We design and build custom outdoor kitchens, patios, sunrooms, decks, pergolas, and water & fire features throughout Gretna — including master-planned backyards built in phases as your budget allows.',
    ],
    localHeading: 'Master Plans for Gretna\'s Growing Neighborhoods',
    localPoints: [
      'Whole-backyard master plans for Gretna\'s larger new-construction lots',
      'Phased build options — design the full vision, build it over time',
      'Outdoor kitchens and covered spaces scaled for serious entertaining',
      'New-build experience: working alongside fresh landscaping and grading',
    ],
    faqs: [
      { q: 'We just built a new home in Gretna. When should we plan the backyard?', a: 'Now is ideal. Designing your outdoor space before final grading and landscaping decisions are made prevents expensive rework — and lets us phase the build intelligently around your budget.' },
      { q: 'Can you design a whole backyard and build it in stages?', a: 'That is one of our specialties. A master plan means phase one (often the patio) is built so phases two and three — kitchen, fire feature, cover — connect seamlessly without tearing anything out.' },
    ],
    nearby: ['omaha-ne', 'papillion-ne', 'ashland-ne', 'wahoo-ne'],
    metaTitle: 'Outdoor Living Gretna, NE | Nebraska Backyard Living',
    metaDescription: "Master-planned outdoor living for Gretna's growing neighborhoods — patios, kitchens & fire features built in phases. Free consultation.",
  },
  {
    slug: 'elkhorn-ne',
    city: 'Elkhorn',
    state: 'Nebraska',
    region: 'Omaha Metro',
    headline: 'Outdoor Living Design & Build in Elkhorn, NE',
    image: IMAGES.homeModern,
    intro: [
      'Elkhorn blends small-town roots with some of west Omaha\'s finest homes — properties where outdoor living is not an afterthought but an expectation. Larger lots, custom architecture, and homeowners with a clear vision make Elkhorn a natural fit for our design-build approach.',
      'From expansive patio and outdoor kitchen environments to sunrooms that complement custom architecture, we design and build throughout Elkhorn with the attention to detail these properties deserve.',
    ],
    localHeading: 'Craftsmanship That Matches Elkhorn Homes',
    localPoints: [
      'Premium outdoor kitchens and covered living spaces for custom homes',
      'Designs that complement high-end architecture and finishes',
      'Larger-lot expertise — multi-zone outdoor environments',
      'Discreet, professional construction process from start to finish',
    ],
    faqs: [
      { q: 'Can you match the finishes and style of my custom Elkhorn home?', a: 'Yes. Matching architecture is core to how we design — stone, brick, rooflines, and trim are selected so your outdoor space reads as original to the home, not added on.' },
      { q: 'What is possible on a larger Elkhorn lot?', a: 'Larger properties allow true multi-zone design: a kitchen and dining zone under cover, a separate fire feature lounge, open lawn preserved for play. We master-plan the whole property so every zone connects naturally.' },
    ],
    nearby: ['omaha-ne', 'millard-ne', 'bennington-ne', 'gretna-ne'],
    metaTitle: 'Outdoor Living & Landscaping Elkhorn, NE | Nebraska Backyard Living',
    metaDescription: 'Premium outdoor kitchens, sunrooms & patio environments for Elkhorn, NE homes. Craftsmanship that matches custom architecture. Free consultation.',
  },
  {
    slug: 'bennington-ne',
    city: 'Bennington',
    state: 'Nebraska',
    region: 'Omaha Metro',
    headline: 'Outdoor Living Design & Build in Bennington, NE',
    image: IMAGES.garden,
    intro: [
      'Bennington keeps its small-town character even as new neighborhoods grow around it — and that mix of old and new makes for wonderful outdoor living projects. Established properties near the lake, fresh builds on the town\'s edge: each deserves a design that fits.',
      'We serve Bennington homeowners with custom patios, decks, pergolas, sunrooms, outdoor kitchens, and water & fire features — with the same free on-site consultations and custom design process we bring to the whole metro.',
    ],
    localHeading: 'Small-Town Character, Thoughtful Design',
    localPoints: [
      'Designs that respect Bennington\'s established, tree-lined properties',
      'New-neighborhood expertise for the community\'s growing edges',
      'Covered spaces and wind-conscious design for open, exposed lots',
      'Water features and fire pits that make quiet evenings something special',
    ],
    faqs: [
      { q: 'Do you serve Bennington as readily as Omaha?', a: 'Yes. Bennington is squarely within our Omaha metro service area. Consultations, design work, and builds all happen on the same schedule and terms as anywhere in the metro.' },
      { q: 'My Bennington lot is exposed to wind. What should I consider?', a: 'Open lots on Bennington\'s growing edges catch real Nebraska wind. We design with it in mind — wind-conscious pergola and cover engineering, fire feature siting, and layouts that create natural shelter.' },
    ],
    nearby: ['elkhorn-ne', 'omaha-ne', 'wahoo-ne', 'gretna-ne'],
    metaTitle: 'Outdoor Living Bennington, NE | Nebraska Backyard Living',
    metaDescription: 'Custom patios, decks, pergolas & outdoor kitchens in Bennington, NE. Wind-smart design for open lots. Free on-site consultation.',
  },
  {
    slug: 'wahoo-ne',
    city: 'Wahoo',
    state: 'Nebraska',
    region: 'Between Omaha & Lincoln',
    headline: 'Outdoor Living Design & Build in Wahoo, NE',
    image: IMAGES.home2,
    intro: [
      'Wahoo sits at the crossroads of our two home markets — the Saunders County seat, right between Omaha and Lincoln, with lake country at its doorstep. It is a community where outdoor life is already part of the culture; a well-designed backyard simply brings more of it home.',
      'Nebraska Backyard Living serves Wahoo homeowners with the full range of our custom design-build services: outdoor kitchens, patios, sunrooms, decks, pergolas, and water & fire features.',
    ],
    localHeading: 'Bringing the Lake-Life Feeling Home',
    localPoints: [
      'Entertaining-focused designs that capture Wahoo\'s lake-country spirit',
      'Experience with the area\'s established homes and rural-edge properties',
      'Durable construction for Saunders County weather exposure',
      'Fire features and covered spaces for long Nebraska evenings',
    ],
    faqs: [
      { q: 'Is Wahoo inside your service area?', a: 'Yes. Wahoo sits between our two core markets of Omaha and Lincoln, and we serve it regularly. Your free on-site consultation works exactly as it would anywhere else we serve.' },
      { q: 'What projects are popular with Wahoo homeowners?', a: 'Fire features and covered patios lead the way here — spaces built for gathering after a day at the lake. Outdoor kitchens are a growing favorite for homeowners who entertain through the summer.' },
    ],
    nearby: ['lincoln-ne', 'ashland-ne', 'bennington-ne', 'omaha-ne'],
    metaTitle: 'Outdoor Living & Landscaping Wahoo, NE | Nebraska Backyard Living',
    metaDescription: 'Patios, fire features, sunrooms & outdoor kitchens in Wahoo, NE. Serving Saunders County from Omaha & Lincoln. Free consultation.',
  },
  {
    slug: 'ashland-ne',
    city: 'Ashland',
    state: 'Nebraska',
    region: 'Between Omaha & Lincoln',
    headline: 'Outdoor Living Design & Build in Ashland, NE',
    image: IMAGES.lawn,
    intro: [
      'Ashland has something most metro communities do not — a setting. Nestled along the Platte River with Mahoney State Park as a neighbor, many Ashland properties back up to trees, bluffs, and genuine Nebraska scenery. Outdoor living design here starts with what the land already gives you.',
      'We design and build custom patios, decks, sunrooms, pergolas, outdoor kitchens, and water & fire features throughout Ashland, with layouts that frame views and work with wooded, sloped, and river-adjacent lots.',
    ],
    localHeading: 'Designing With the Landscape, Not Against It',
    localPoints: [
      'View-oriented designs for wooded and river-adjacent properties',
      'Deck and patio solutions for Ashland\'s sloped and natural lots',
      'Screened spaces that keep river-country insects out of your evenings',
      'Fire features sited for views, wind, and Nebraska night skies',
    ],
    faqs: [
      { q: 'My Ashland lot slopes toward the trees. Can you work with that?', a: 'Sloped and wooded lots are some of our favorite canvases. Multi-level decks, terraced patios, and view-framed fire features turn challenging topography into the property\'s best feature.' },
      { q: 'Are screened enclosures worth it near the river?', a: 'Many Ashland homeowners tell us they are essential. A screened patio room or sunroom lets you enjoy river-country evenings without sharing them with mosquitoes — while keeping the views that drew you to the property.' },
    ],
    nearby: ['gretna-ne', 'wahoo-ne', 'lincoln-ne', 'omaha-ne'],
    metaTitle: 'Outdoor Living & Landscaping Ashland, NE | Nebraska Backyard Living',
    metaDescription: "Decks, patios, sunrooms & fire features for Ashland's wooded & river-adjacent lots. View-oriented design. Free consultation: (402) 202-9111.",
  },
];

export const getLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
